import {useState} from 'react';
import {InlineStack, Icon, IconProps, IconSource, Text} from '@shopify/polaris';
import {LanguageTranslateIcon} from '@shopify/polaris-icons';
import {DateStyle, useI18n} from '@shopify/react-i18n';
import classNames from 'classnames';

import Styles from './FieldStatus.scss';
import {FieldStatusEnum} from './types';

export interface Props {
  status: keyof typeof FieldStatusEnum;
  detailed?: boolean;
  updatedAt?: string;
}

export function FieldStatus({status, detailed = false, updatedAt}: Props) {
  const [i18n] = useI18n();
  const [hovered, setHovered] = useState(false);

  let icon: IconSource | null = null;
  let color: IconProps['tone'];
  let content: string;

  if (status === FieldStatusEnum.AutoTranslated) {
    icon = LanguageTranslateIcon;
    color = 'base';
    content = i18n.translate('FieldStatus.autoTranslated');
  } else if (status === FieldStatusEnum.LastSaved && updatedAt) {
    color = 'base';
    content = i18n.translate('FieldStatus.lastSaved', {
      datetime: i18n.formatDate(new Date(updatedAt), {
        style: DateStyle.Humanize,
      }),
    });
  } else if (status === FieldStatusEnum.Edited) {
    color = 'base';
    content = i18n.translate('FieldStatus.edited');
  } else {
    return null;
  }

  return (
    <div
      className={classNames(
        detailed ? Styles.FieldStatus_details : Styles.FieldStatus_quickView,
      )}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <InlineStack gap="200" align="start">
        {icon && (
          <Icon
            source={icon}
            tone={detailed || hovered ? color : 'subdued'}
            accessibilityLabel={content}
          />
        )}
        {detailed && (
          <Text as="p" variant="bodyMd">
            {content}
          </Text>
        )}
      </InlineStack>
    </div>
  );
}
